import React, { useState } from "react";
import {
    Dialog,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ReasonModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (reasonName: string) => void;
}

const ReasonModal = ({ open, onClose, onSave }: ReasonModalProps) => {
    const [value, setValue] = useState("");
    const [saving, setSaving] = useState(false);

    const handleSave = () => {
        if (!value.trim()) return;
        setSaving(true);
        onSave(value.trim());
        setValue("");
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "20px",
                    overflow: "hidden",
                },
            }}
        >
            <Box sx={{ width: 380, p: 3, background: "#f7f7f7" }}>
                {}
                <Box display="flex" justifyContent="flex-end">
                    <IconButton size="small" onClick={onClose} disabled={saving}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {}
                <Typography sx={{ mb: 2, fontSize: "14px", fontWeight: 500 }}>
                    Adjustment Reason
                </Typography>

                {}
                <TextField
                    fullWidth
                    size="small"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    disabled={saving}
                    placeholder="Enter reason name"
                />

                {}
                <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                    <Button
                        variant="contained"
                        onClick={onClose}
                        disabled={saving}
                        sx={{
                            background: "#6c757d",
                            color: "#fff",
                            borderRadius: "25px",
                            px: 3,
                            textTransform: "none",
                            "&:hover": { background: "#5a6268" },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={!value.trim() || saving}
                        sx={{
                            background: "#000",
                            color: "#fff",
                            borderRadius: "25px",
                            px: 3,
                            textTransform: "none",
                            "&:hover": { background: "#222" },
                        }}
                    >
                        {saving ? "Saving..." : "Save"}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default ReasonModal;